import { FC } from 'react'

import styles from './EmptyListPlaceholder.module.scss'

export const EmptyListPlaceholder: FC = () => {
  return <span className={styles.root}>Nothing to show here</span>
}
